import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { client } from 'cogsworth/utils/ApolloClient'

import paypalExecutePaymentMutation from 'graphql/mutations/paypalExecutePayment'

class PayPalForm extends Component {
  static propTypes = {
    businessId: PropTypes.string.isRequired,
    payee: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    onPaymentComplete: PropTypes.func.isRequired,
    onPaymentDeclined: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
  }

  componentDidMount() {
    let { amount } = this.props
    const { businessId, payee, currency, description, requirePaypalShippingAddress, coupon } = this.props

    if (coupon) {
      amount = coupon.price
    }

    window.paypal.Button.render({
      env: window.location.href.indexOf('www.cogsworth.com') !== -1 ? 'production' : 'sandbox',
      style: {
        size: 'responsive',
        tagline: false,
      },

      // "Cogsworth" application in developer account
      client: {
        sandbox: 'AZ7DntN-eLKhEq3yPKIZdfyv213k5sVqksTXRtdN6aldayYcVwWzwgAO6AIKfU93OFMADQzPbUPm7z5m',
        production: 'AYlTCk0o2nDLVoosTtrf0rI9wvlCRk3ZI-MbsrxRl_MCfWvA7uNE5S3ahgb-b7qOdV9C2TQlx0yudV1W',
      },
      commit: true,
      payment: (data, actions) => {
        console.log('paypal.Button.payment()', amount, currency, payee)
        return actions.payment.create({
          payment: {
            transactions: [
              {
                amount: {
                  total: amount,
                  currency,
                },
                payee: {
                  email: payee,
                },
                description,
              }
            ],
          },
          experience: {
            input_fields: {
              no_shipping: requirePaypalShippingAddress ? 0 : 1,
            },
          }
        });
      },
      onAuthorize: async (data, actions) => {
        console.log('paypal.Button.onAuthorize()', data)
        const { onPaymentComplete, onPaymentDeclined } = this.props
        const { intent, orderID:orderId, payerID:payerId, paymentID:paymentId, paymentToken, returnURL:returnUrl } = data

        const { data: { paypalExecutePayment: { response = {} } } } = await client.mutate({
          mutation: paypalExecutePaymentMutation,
          variables: {
            businessId,
            intent,
            orderId,
            payerId,
            paymentId,
            paymentToken,
            returnUrl,
          },
        })

        if (response.state === "approved" || response.state === "created") {
          onPaymentComplete(response, 'paypal')
        } else {
          onPaymentDeclined(response, 'paypal')
        }
      },
      onCancel: (data) => {
        console.log('paypal.Button.onCancel()', data)
      },
      onError: (data) => {
        console.log('paypal.Button.onError()', data)
      },
    }, '#paypal-checkout-button')
  }

  render() {
    return (
      <div id="paypal-form">
        <small>Click the PayPal button below to process payment securely with PayPal.</small>
        <div id="paypal-checkout-button"></div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  coupon: state.coupon,
})

export default connect(mapStateToProps)(PayPalForm)
